"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadFormStepType = exports.OpenAnswerStepType = exports.TutorialStepType = exports.DialogueStepType = exports.MultipleChoiceStepType = exports.ScoringResultsStepType = exports.VoiceInputStepType = exports.PlayMediaStepType = exports.BaseActivityStepType = void 0;
const SupportedTypes_1 = require("../SupportedTypes");
const IAsset_1 = require("../IAsset");
class BaseActivityStepType {
    static getInstanceForObject(item) {
        switch (item.type) {
            case SupportedTypes_1.SupportedTypes.voiceInput.id:
                return Object.assign(new VoiceInputStepType(item));
            case SupportedTypes_1.SupportedTypes.playMedia.id:
                return Object.assign(new PlayMediaStepType(item));
            case SupportedTypes_1.SupportedTypes.scoringResults.id:
                return Object.assign(new ScoringResultsStepType(item));
            case SupportedTypes_1.SupportedTypes.multipleChoice.id:
                return Object.assign(new MultipleChoiceStepType(item));
            case SupportedTypes_1.SupportedTypes.dialogue.id:
                return Object.assign(new DialogueStepType(item));
            case SupportedTypes_1.SupportedTypes.tutorial.id:
                return Object.assign(new TutorialStepType(item));
            case SupportedTypes_1.SupportedTypes.openAnswer.id:
                return Object.assign(new OpenAnswerStepType(item));
            case SupportedTypes_1.SupportedTypes.leadForm.id:
                return Object.assign(new LeadFormStepType(item));
        }
        return null;
    }
    constructor({ id, type, asset }) {
        this.scoreMultiplier = 1;
        this.id = id;
        this.type = type;
        this.asset = asset;
    }
    getAssetIds() {
        var _a, _b, _c;
        return ((_a = this.asset) === null || _a === void 0 ? void 0 : _a.id) && (((_c = (_b = this.asset.type) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) === 0 || this.asset.type === IAsset_1.AssetType.internal) ? [this.asset.id] : [];
    }
}
exports.BaseActivityStepType = BaseActivityStepType;
class PlayMediaStepType extends BaseActivityStepType {
    constructor({ id, type, title, content, asset, autoPlay, continueOnPlaybackComplete, duration, canSkip, options, videoSubtitles }) {
        super({ id, type, asset });
        this.title = title;
        this.content = content;
        this.autoPlay = autoPlay;
        this.continueOnPlaybackComplete = continueOnPlaybackComplete;
        this.duration = duration;
        this.canSkip = canSkip;
        this.options = options;
        this.videoSubtitles = videoSubtitles;
    }
    getAssetIds() {
        var _a, _b, _c, _d;
        const assetIds = super.getAssetIds();
        for (const subtitle of (_b = (_a = this.videoSubtitles) === null || _a === void 0 ? void 0 : _a.subtitles) !== null && _b !== void 0 ? _b : []) {
            if ((_c = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _c === void 0 ? void 0 : _c.id) {
                assetIds.push((_d = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _d === void 0 ? void 0 : _d.id);
            }
        }
        return assetIds;
    }
    static createWithDefaults(id) {
        return new PlayMediaStepType({
            id: id,
            type: SupportedTypes_1.SupportedTypes.playMedia.id,
            title: "",
            content: "",
            asset: null,
            autoPlay: false,
            continueOnPlaybackComplete: false,
            duration: 0,
            canSkip: false,
            options: {
                leftAlignedText: false
            },
            videoSubtitles: null
        });
    }
}
exports.PlayMediaStepType = PlayMediaStepType;
class VoiceInputStepType extends BaseActivityStepType {
    constructor({ id, type, title, content, sentence, asset, allowAudioPreview, allowTryAgain, ttsAsset, options, videoSubtitles }) {
        super({ id, type, asset });
        this.ttsAsset = null;
        this.title = title;
        this.content = content;
        this.sentence = sentence;
        this.allowAudioPreview = allowAudioPreview;
        this.allowTryAgain = allowTryAgain;
        this.ttsAsset = ttsAsset;
        this.options = options;
        this.videoSubtitles = videoSubtitles;
    }
    getAssetIds() {
        var _a, _b, _c, _d, _e, _f;
        const assetIds = super.getAssetIds();
        if ((_a = this.ttsAsset) === null || _a === void 0 ? void 0 : _a.id) {
            assetIds.push((_b = this.ttsAsset) === null || _b === void 0 ? void 0 : _b.id);
        }
        for (const subtitle of (_d = (_c = this.videoSubtitles) === null || _c === void 0 ? void 0 : _c.subtitles) !== null && _d !== void 0 ? _d : []) {
            if ((_e = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _e === void 0 ? void 0 : _e.id) {
                assetIds.push((_f = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _f === void 0 ? void 0 : _f.id);
            }
        }
        return assetIds;
    }
    static createWithDefaults(id) {
        return new VoiceInputStepType({
            id: id,
            type: SupportedTypes_1.SupportedTypes.voiceInput.id,
            title: "",
            content: "",
            sentence: "",
            asset: null,
            allowAudioPreview: true,
            allowTryAgain: true,
            ttsAsset: null,
            options: {
                leftAlignedText: false
            },
            videoSubtitles: null
        });
    }
}
exports.VoiceInputStepType = VoiceInputStepType;
class ScoringResultsStepType extends BaseActivityStepType {
    constructor({ id, type, options, content, asset, externalLinkTitle, externalLinkUrl, videoSubtitles }) {
        super({ id, type, asset });
        this.options = options;
        this.content = content;
        this.externalLinkTitle = externalLinkTitle;
        this.externalLinkUrl = externalLinkUrl;
        this.videoSubtitles = videoSubtitles;
    }
    getAssetIds() {
        var _a, _b, _c, _d;
        const assetIds = super.getAssetIds();
        for (const subtitle of (_b = (_a = this.videoSubtitles) === null || _a === void 0 ? void 0 : _a.subtitles) !== null && _b !== void 0 ? _b : []) {
            if ((_c = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _c === void 0 ? void 0 : _c.id) {
                assetIds.push((_d = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _d === void 0 ? void 0 : _d.id);
            }
        }
        return assetIds;
    }
    static createWithDefaults(id) {
        return new ScoringResultsStepType({
            id: id,
            type: SupportedTypes_1.SupportedTypes.scoringResults.id,
            options: {
                showExternalLink: false,
                leftAlignedText: false,
                skipSaveResults: false,
                hideSocialButtons: false
            },
            content: "",
            asset: null,
            externalLinkTitle: null,
            externalLinkUrl: null,
            videoSubtitles: null
        });
    }
}
exports.ScoringResultsStepType = ScoringResultsStepType;
class MultipleChoiceStepType extends BaseActivityStepType {
    constructor({ id, type, title, content, asset, choiceOptions, allowTryAgain, answerType, duration, durationAffectsScore, doNotRandomizeAnswers, options, videoSubtitles }) {
        super({ id, type, asset });
        this.title = title;
        this.content = content;
        this.choiceOptions = choiceOptions;
        this.allowTryAgain = allowTryAgain;
        this.answerType = answerType;
        this.duration = duration;
        this.durationAffectsScore = durationAffectsScore;
        this.doNotRandomizeAnswers = doNotRandomizeAnswers;
        this.options = options;
        this.videoSubtitles = videoSubtitles;
    }
    getAssetIds() {
        var _a, _b, _c, _d;
        const assetIds = super.getAssetIds();
        for (const subtitle of (_b = (_a = this.videoSubtitles) === null || _a === void 0 ? void 0 : _a.subtitles) !== null && _b !== void 0 ? _b : []) {
            if ((_c = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _c === void 0 ? void 0 : _c.id) {
                assetIds.push((_d = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _d === void 0 ? void 0 : _d.id);
            }
        }
        return assetIds;
    }
    static createWithDefaults(id) {
        return new MultipleChoiceStepType({
            id: id,
            type: SupportedTypes_1.SupportedTypes.multipleChoice.id,
            title: "",
            content: "",
            asset: null,
            choiceOptions: [
                {
                    id: 0,
                    content: "",
                    isCorrect: false
                }
            ],
            allowTryAgain: true,
            answerType: 0,
            duration: 0,
            durationAffectsScore: false,
            doNotRandomizeAnswers: false,
            options: {
                leftAlignedText: false,
                hideResult: false,
                allowMultiOption: false
            },
            videoSubtitles: null
        });
    }
    static migrate(originalStep) {
        var _a, _b;
        const legacySentenceCount = (_b = (_a = originalStep.sentences) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        if (legacySentenceCount > 0 && !originalStep.choiceOptions) {
            originalStep.choiceOptions = [];
            for (let i = 0; i < legacySentenceCount; i++) {
                let item = {
                    id: i,
                    content: originalStep.sentences ? originalStep.sentences[i] : "",
                    isCorrect: originalStep.correctAnswerIndex === i
                };
                originalStep.choiceOptions.push(item);
            }
            delete originalStep.sentences;
            delete originalStep.correctAnswerIndex;
        }
    }
}
exports.MultipleChoiceStepType = MultipleChoiceStepType;
class DialogueStepType extends BaseActivityStepType {
    constructor({ id, type, roles, sentences, options, learnerLevel, learnerRoleId }) {
        super({ id, type, asset: null });
        this.roles = roles;
        this.sentences = sentences;
        this.options = options;
        this.learnerLevel = learnerLevel;
        this.learnerRoleId = learnerRoleId;
    }
    getAssetIds() {
        var _a, _b, _c, _d;
        const assetIds = [
            ...super.getAssetIds(),
            ...this.roles.filter(e => { var _a, _b, _c; return ((_c = (_b = (_a = e.avatarAsset) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0; }).map(e => { var _a, _b; return (_b = (_a = e.avatarAsset) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ""; })
        ];
        // Add sentence assets
        for (const sentence of this.sentences) {
            if ((_a = sentence.asset) === null || _a === void 0 ? void 0 : _a.id) {
                assetIds.push(sentence.asset.id);
            }
            // Add sentence video subtitles
            for (const subtitle of (_c = (_b = sentence === null || sentence === void 0 ? void 0 : sentence.videoSubtitles) === null || _b === void 0 ? void 0 : _b.subtitles) !== null && _c !== void 0 ? _c : []) {
                if ((_d = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _d === void 0 ? void 0 : _d.id) {
                    assetIds.push(subtitle.asset.id);
                }
            }
        }
        return assetIds;
    }
    static createWithDefaults(id, defaultTtsVoice) {
        return new DialogueStepType({
            id: id,
            type: SupportedTypes_1.SupportedTypes.dialogue.id,
            roles: [
                {
                    id: 1,
                    name: "",
                    avatarAsset: null,
                    ttsVoice: defaultTtsVoice
                },
                {
                    id: 2,
                    name: "",
                    avatarAsset: null,
                    ttsVoice: defaultTtsVoice
                }
            ],
            sentences: [],
            learnerRoleId: null,
            learnerLevel: 0,
            options: {
                allowTryAgain: true,
                allowSwitchingRoles: false,
                displayResults: true
            }
        });
    }
}
exports.DialogueStepType = DialogueStepType;
class TutorialStepType extends BaseActivityStepType {
    constructor({ id, type, title, instruction, asset, slides, options, videoSubtitles }) {
        super({ id, type, asset: null });
        this.title = title;
        this.instruction = instruction;
        this.asset = asset;
        this.slides = slides;
        this.options = options;
        this.videoSubtitles = videoSubtitles;
    }
    getAssetIds() {
        var _a, _b, _c, _d, _e, _f, _g;
        const assetIds = super.getAssetIds();
        // Add root subtitles
        for (const subtitle of (_b = (_a = this.videoSubtitles) === null || _a === void 0 ? void 0 : _a.subtitles) !== null && _b !== void 0 ? _b : []) {
            if ((_c = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _c === void 0 ? void 0 : _c.id) {
                assetIds.push(subtitle.asset.id);
            }
        }
        // Add slide assets
        for (const slide of this.slides) {
            if ((_d = slide.asset) === null || _d === void 0 ? void 0 : _d.id) {
                assetIds.push(slide.asset.id);
            }
            // Add slide video subtitles
            for (const subtitle of (_f = (_e = slide === null || slide === void 0 ? void 0 : slide.videoSubtitles) === null || _e === void 0 ? void 0 : _e.subtitles) !== null && _f !== void 0 ? _f : []) {
                if ((_g = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _g === void 0 ? void 0 : _g.id) {
                    assetIds.push(subtitle.asset.id);
                }
            }
        }
        return assetIds;
    }
    static createWithDefaults(id) {
        return new TutorialStepType({
            id: id,
            type: SupportedTypes_1.SupportedTypes.tutorial.id,
            title: null,
            instruction: null,
            asset: null,
            slides: [
                {
                    id: 1,
                    text: "",
                    asset: null,
                    leftAlignedText: false,
                    videoSubtitles: null
                }
            ],
            options: {
                nextOnlyOnLastSlide: false,
                leftAlignedText: false
            },
            videoSubtitles: null
        });
    }
}
exports.TutorialStepType = TutorialStepType;
class OpenAnswerStepType extends BaseActivityStepType {
    constructor({ id, type, title, content, asset, options, videoSubtitles }) {
        super({ id, type, asset });
        this.title = title;
        this.content = content;
        this.options = options;
        this.videoSubtitles = videoSubtitles;
    }
    getAssetIds() {
        var _a, _b, _c, _d;
        const assetIds = super.getAssetIds();
        for (const subtitle of (_b = (_a = this.videoSubtitles) === null || _a === void 0 ? void 0 : _a.subtitles) !== null && _b !== void 0 ? _b : []) {
            if ((_c = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _c === void 0 ? void 0 : _c.id) {
                assetIds.push((_d = subtitle === null || subtitle === void 0 ? void 0 : subtitle.asset) === null || _d === void 0 ? void 0 : _d.id);
            }
        }
        return assetIds;
    }
    static createWithDefaults(id) {
        return new OpenAnswerStepType({
            id: id,
            type: SupportedTypes_1.SupportedTypes.openAnswer.id,
            title: "",
            content: "",
            asset: null,
            options: {
                answerType: 0,
                allowTryAgain: false,
                duration: 0,
                preparationTime: 0,
                testMode: false,
                leftAlignedText: false,
                prefillStorageKey: undefined
            },
            videoSubtitles: null
        });
    }
}
exports.OpenAnswerStepType = OpenAnswerStepType;
class LeadFormStepType extends BaseActivityStepType {
    constructor({ id, type, title, content, asset, options, items }) {
        super({ id, type, asset });
        this.title = title;
        this.content = content;
        this.options = options;
        this.items = items;
    }
    static createWithDefaults(id) {
        return new LeadFormStepType({
            id: id,
            type: SupportedTypes_1.SupportedTypes.leadForm.id,
            title: "",
            content: "",
            options: {
                submitButtonAlignment: "center"
            },
            asset: null,
            items: []
        });
    }
}
exports.LeadFormStepType = LeadFormStepType;
